import React from "react";
import "./Error.css";

const Error = () => {
  return (
    <div className="error-container">
    <div className="message">
      <h1>Erreur de vérification</h1>
      <p>Les informations fournies sont invalides ou expirées</p>
    </div></div>
  );
};

export default Error;
